import React, { FC } from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ImageGrid from "./image-grid";
import BadgeImage from "./ui-elements/badge-image";
import useResponsive from "../hooks/useResponsive";
import { NewsfeedProps } from "../interface/newsfeed";
import {
  formatDateAndTimeFromString,
  formatTextType,
} from "../utils/date-setup";
import { Link } from "react-router-dom";

interface NewsfeedContainerPropsType {
  profileImg: any;
  name: string;
  date: string;
  contents: string;
  image: any;
  social: {
    message: number;
    repost: number;
    like: number;
  };
}

const NewsFeedContainer: FC<NewsfeedProps> = ({
  report_id,
  entity_value,
  place_admin_level,
  place_geocode_name,
  report_title,
  report_content,
  report_url,
  report_date_published,
  source_name,
  source_type_name,
  post_type,
  author,
  author_id,
  incident_type,
}) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  return (
    <Box
      sx={{
        minHeight: 200,
        border: "1px solid rgba(231, 235, 239, 1)",
        my: 2,
        borderRadius: "8px",
        padding: isMedium ? 1 : 2,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          gap: 1,
          mb: 3,
        }}
      >
        <img
          src={"/assets/images/account/cover-bg.jpeg"}
          style={{ width: 50, height: 50, borderRadius: 40 }}
        />
        <Stack>
          <Stack direction={"row"} spacing={1}>
            <Typography variant="subtitle2" color="black">
              {author}
            </Typography>
            {/* <BadgeImage badge={1} /> */}
          </Stack>

          <Typography
            variant="caption"
            sx={{
              color: "#4A5E6D",
              fontWeight: 400,
            }}
          >
            {formatTextType(post_type)}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: "#4A5E6D",
              fontWeight: 400,
            }}
          >
            {formatDateAndTimeFromString(report_date_published)}
          </Typography>
        </Stack>
      </Box>
      <Box sx={{ ml: isMedium ? 0 : 3 }}>
        {/* <ImageGrid images={image} onImagePress={() => {}} /> */}
      </Box>
      <Box
        sx={{
          ml: isMedium ? 0 : 3,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            fontWeight: 500,
          }}
        >
          {formatTextType(report_title)}
        </Typography>
        <Box sx={{ mt: "10px", cursor: "pointer" }}>
          <Link
            to={report_url}
            target="__blank"
            style={{ textDecorationLine: "none" }}
          >
            <Typography
              variant="caption"
              sx={{
                color: "#4A5E6D",
              }}
            >
              {report_content}
            </Typography>
          </Link>
        </Box>
        <Stack direction={"column"} sx={{ my: 2 }} spacing={0.5}>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 500,
            }}
          >
            {formatTextType(source_name)}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 500,
            }}
          >
            {formatTextType(source_type_name)}
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontWeight: 500,
            }}
          >
            {formatTextType(entity_value)}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default NewsFeedContainer;
